export const _initialState = {
  showDrawer: false,
  promo: {},
  totalPrice: {
    value: '0.00',
    dollarOff: '0.00',
    percentOff: '0',
    originalPrice: '0.00',
  },
  promoTotal: 0,
  productsWithRewardTiers: [],
  fulfillmentProducts: [],
  discounts: {}
};
